// Target ACOS and break-even (TgACOS): report columns, the Amazon → PPC → Performance Targets
// page, inline and bulk Target ACOS editing and the "(fixed)" header renames. Stage and prod run
// the prod olap-server, which rejects tg_*/be_* fields until TGACOS_REPORT_COLUMNS is on there,
// so with the flag off none of these columns, pages, routes or menu items exist. Set it
// identically in .env.staging and .env.production (stage mirrors prod).
export const targetAcosEnabled = import.meta.env.VITE_ENABLE_TARGET_ACOS === 'true';

export const PERFORMANCE_TARGETS_PATH = 'Amazon → PPC → Performance Targets';
export const NO_TARGET_HINT = `No target set. Set one in ${PERFORMANCE_TARGETS_PATH}`;
export const NO_BREAK_EVEN_HINT =
  `No break-even: COGS missing (COGS page) or no SP-API data (${PERFORMANCE_TARGETS_PATH} → Break-even)`;
